import React from 'react'
import {FormattedMessage} from 'react-intl'
import {Text} from '@chakra-ui/react'
import {useBasket} from '_customHooks'

const MinicartHeader = () => {
    const {basketProductsCount} = useBasket()

    return (
        <Text as="span" data-testid="minicart-header-title">
            <FormattedMessage id="label.num.items" defaultMessage="YOUR SELECTION ( {0} )" values={{0: basketProductsCount}} />
        </Text>
    )
}

export {MinicartHeader}
